import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const Square3Stack3dIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="outline/square-3-stack-3d"><path id="Icon" d="M17.5714 9.75L21.75 12L17.5714 14.25L12 17.25L6.42857 14.25L2.25 12L6.42857 9.75M17.5714 9.75L21.75 7.5L12 2.25L2.25 7.5L6.42857 9.75L12 12.75L17.5714 9.75ZM17.5714 14.25L21.75 16.5L12 21.75L2.25 16.5L6.42857 14.25" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" /></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default Square3Stack3dIcon;